import makeStyles from '@mui/styles/makeStyles';
import React from 'react'

const useStyles = makeStyles(theme => ({
    controlContainer: {
        display: 'flex',
        flexDirection: 'row-reverse',
        gap: theme.spacing(1),
        marginTop: 60
    }
}))

const ControlContainer: React.FC = ({ children }) => {
    const classes = useStyles()


    return <div className={classes.controlContainer}>
        {children}
    </div>
}

export default ControlContainer
